
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[code]",
      function () {
        return require("private-next-pages/faq/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/[code]"])
      });
    }
  